import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { Device } from '@rocksoft/shared';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'ml-mdm-devices-ag-grid-cell-renderer',
  templateUrl: './mdm-devices-ag-grid-cell-renderer.component.html',
  imports: [RouterLinkActive, RouterLink, FaIconComponent, DatePipe],
})
export class MdmDevicesAgGridCellRendererComponent implements ICellRendererAngularComp {
  public device: Device;

  agInit(params: ICellRendererParams): void {
    this.device = params.data;
  }

  refresh(): boolean {
    return false;
  }
}
